import { __extends } from "tslib";
import { StatusEnum } from "../const/StatusEnum";
/**
 * 全局异常类
 * 使用: throw new Exception(StatusEnum.HTTP_ERROR, "any message")
 */
var Exception = /** @class */ (function (_super) {
    __extends(Exception, _super);
    /**
     * @param code 异常编码，由 StatusEnum 统一管理
     * @param message 异常消息内容
     */
    function Exception(code, message) {
        var _this = _super.call(this, message || "" + code) || this;
        _this.code = code;
        _this.message = message;
        return _this;
    }
    Exception.prototype.toString = function () {
        return this.code + " - " + this.message;
    };
    return Exception;
}(Error));
export { Exception };
var ParamTypeException = /** @class */ (function (_super) {
    __extends(ParamTypeException, _super);
    function ParamTypeException(message) {
        return _super.call(this, StatusEnum.PARAM_TYPE_NOT_VALID, message) || this;
    }
    return ParamTypeException;
}(Exception));
export { ParamTypeException };
var ConfigNotFoundException = /** @class */ (function (_super) {
    __extends(ConfigNotFoundException, _super);
    function ConfigNotFoundException(configName) {
        return _super.call(this, StatusEnum.CONFIG_NOT_FOUND, "Can not find [" + configName + "] in window.") || this;
    }
    return ConfigNotFoundException;
}(Exception));
export { ConfigNotFoundException };
var FeatureNotSupportException = /** @class */ (function (_super) {
    __extends(FeatureNotSupportException, _super);
    function FeatureNotSupportException(feature) {
        return _super.call(this, StatusEnum.FEATURE_NOT_SUPPORT, "Your browser does not support " + feature + ".") || this;
    }
    return FeatureNotSupportException;
}(Exception));
export { FeatureNotSupportException };
var NamespaceNotValidException = /** @class */ (function (_super) {
    __extends(NamespaceNotValidException, _super);
    function NamespaceNotValidException(namespace) {
        return _super.call(this, StatusEnum.NAMESPACE_NOT_VALID, "Namespace [" + namespace + "] is not valid.") || this;
    }
    return NamespaceNotValidException;
}(Exception));
export { NamespaceNotValidException };
var EventHandlerEmptyException = /** @class */ (function (_super) {
    __extends(EventHandlerEmptyException, _super);
    function EventHandlerEmptyException(message) {
        return _super.call(this, StatusEnum.EVENT_HANDLER_EMPTY, message || "Event handler already empty.") || this;
    }
    return EventHandlerEmptyException;
}(Exception));
export { EventHandlerEmptyException };
var RequestUrlNotValidException = /** @class */ (function (_super) {
    __extends(RequestUrlNotValidException, _super);
    function RequestUrlNotValidException(url) {
        return _super.call(this, StatusEnum.REQUEST_URL_NOT_VALID, "Request url [" + url + "] not valid.") || this;
    }
    return RequestUrlNotValidException;
}(Exception));
export { RequestUrlNotValidException };
var RoutePatternNotFoundException = /** @class */ (function (_super) {
    __extends(RoutePatternNotFoundException, _super);
    function RoutePatternNotFoundException(route) {
        return _super.call(this, StatusEnum.ROUTE_PATTERN_NOT_FOUND, "Can not find route pattern [" + route + "].") || this;
    }
    return RoutePatternNotFoundException;
}(Exception));
export { RoutePatternNotFoundException };
var ParamMissingException = /** @class */ (function (_super) {
    __extends(ParamMissingException, _super);
    function ParamMissingException(param) {
        return _super.call(this, StatusEnum.PARAM_MISSING, "Function [" + param + "] is missing.") || this;
    }
    return ParamMissingException;
}(Exception));
export { ParamMissingException };
var ParamNotValidException = /** @class */ (function (_super) {
    __extends(ParamNotValidException, _super);
    function ParamNotValidException(param) {
        return _super.call(this, StatusEnum.PARAM_NOT_VALID, "Function param [" + JSON.stringify(param) + "] not valid.") || this;
    }
    return ParamNotValidException;
}(Exception));
export { ParamNotValidException };
var UrlRouteException = /** @class */ (function (_super) {
    __extends(UrlRouteException, _super);
    function UrlRouteException(route) {
        return _super.call(this, StatusEnum.URL_ROUTE_ERROR, "Function param [" + route + "] not valid.") || this;
    }
    return UrlRouteException;
}(Exception));
export { UrlRouteException };
